import { AppInfo, RestoredListenerEvent } from "@src-capacitor/@capacitor/app"
import { defineStore } from "pinia"

export interface CapacitorAppInfoStoreType {
  isAppActive: boolean
  hasInternet: boolean
  appInfo: AppInfo | null
  restoredEvent: RestoredListenerEvent | null
}

export const useCapacitorAppInfoStore = defineStore("pinia-capacitorAppInfoStore", {
  // We don't want to save unnecessary data. This store is only used for platform state detection.
  persist: false,

  state: (): CapacitorAppInfoStoreType => ({
    isAppActive: true,
    hasInternet: true,
    appInfo: null,
    restoredEvent: null,
  }),

  actions: {
    setAppState(isActive: boolean) {
      this.isAppActive = isActive
    },

    setAppInfo(appInfo: AppInfo) {
      this.appInfo = appInfo
    },

    setRestoredEvent(event: RestoredListenerEvent) {
      this.restoredEvent = event
    },
  },
})
